
import { VendorsTable } from "components";

const Vendors = () => {

    return (
        <VendorsTable/>
    );

}
export default Vendors;